<div class="region-feature" [class._noBorder]="hideSeparator" [class._noPadding]="!padding">
    <fieldset [ngModelGroup]="groupName" class="flex-column">
        <div class="flex-row center-align">
            <div class="flex-column grow space-right-30">
                <label class="label-title" *ngIf="showLabel"
                       [i18n]="[{target: 'innerHTML', key: translationNode + '.label'}]">
                </label>
                <span class="dspl-block inner-space-top-8">
                    <i class="fa fa-info-circle space-right-5"></i>
                    <span [i18n]="[{target: 'innerHTML', key: translationNode + '.description'}]"></span> <br>
                    <span *ngIf="displayMoreDescription"
                        [i18n]="[{target: 'innerHTML', key: translationNode + '.more-description'}]"></span>
                </span>
            </div>
            <div class="region-feature-toggle">
                <div>
                    <app-switcher *ngIf="displayMode === 'BOOLEAN_MODE'"
                                  [labelKey]="'regions.form.features.on-off.label'"
                                  [(ngModel)]="value"
                                  [name]="groupName + 'Value'"
                                  (change)="valueChanged()"
                                  [class.space-right-25]="overrideAbility">
                    </app-switcher>
                    <app-switcher
                        *ngIf="displayMode === RegionFeatureDisplayMode.ON_OFF_FEATURE_MODE"
                        [labelKey]="'regions.form.features.available.label'"
                        [(ngModel)]="onOffValue"
                        [name]="groupName + 'Available'"
                        (change)="onOffValueChanged()"
                        [disabled]="disabled"
                        [class.space-right-25]="overrideAbility">
                    </app-switcher>
                    <app-switcher
                        *ngIf="displayMode === RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [labelKey]="'regions.form.features.available.label'"
                        [(ngModel)]="inheritedOnOffValue"
                        [name]="groupName + 'Available'"
                        (change)="inheritedOnOffValueChanged()"
                        [disabled]="disabled"
                        [class.space-right-25]="overrideAbility">
                    </app-switcher>
                </div>
                <div>
                    <app-switcher #switcher *ngIf="!!overrideAbility"
                                  [labelKey]="'regions.form.features.override-ability.label'"
                                  [(ngModel)]="overridable"
                                  [name]="groupName + 'OverrideAbility'"
                                  (change)="overridableChanged()"
                                  [disabled]="disabled">
                    </app-switcher>
                </div>
            </div>
        </div>
        <div class="space-top-10">
                <span *ngIf="selectDescription"
                      [i18n]="[{target: 'innerHTML', key: translationNode + '.select-description'}]"></span>
            <ng-select class="full-width" *ngIf="displayMode === 'MULTI_SELECTION_MODE'"
                       [name]="groupName + 'Value'"
                       [addTag]="false"
                       [hideSelected]="false"
                       [(ngModel)]="value"
                       [required]="true"
                       (change)="valueChanged()"
                       [clearable]="clearable"
                       [disabled]="disabled">
                <ng-option *ngFor="let possibleValue of possibleValues"
                           [value]="possibleValue.value"
                           [i18n]="[{target: 'innerHTML', key: possibleValue.labelKey}]"></ng-option>
            </ng-select>
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </fieldset>
</div>

<ng-template #overrideWarning>
    <div
        [i18n]="[{target: 'innerHTML', key: 'regions.form.features.override-ability.warning.content', params: { flag: getFlagLabel(), count: this.warningCount }}]"></div>
    <br>
    <div [i18n]="'regions.form.features.override-ability.warning.impact'"></div>
    <ul class="impacted-carriers">
        <li class="impacted-carrier" *ngFor="let carrier of warningCarriers">{{ carrier.name }} ({{ carrier.code }})
        </li>
    </ul>
</ng-template>
